export const useKeyboardShortcuts = () => {}; export const KeyboardShortcutsHelp = () => null;
